import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitContentMarkdown.module.scss';

const MarkdownLink = ({
  link,
  content,
  onClick,
  isReviewing = false,
  linkTarget = '_blank',
  shouldTruncateLink = false,
}) => {
  if (!isReviewing) {
    return (
      <a
        href={link}
        className={classnames(styles.linkAnchor, {
          [styles.isShortLink]: shouldTruncateLink,
        })}
        target={linkTarget}
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {content}
      </a>
    );
  }

  return (
    <span className={classnames(isReviewing && styles.isDeleting)}>
      {content}
    </span>
  );
};

MarkdownLink.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  link: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isReviewing: PropTypes.bool,
  linkTarget: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
  shouldTruncateLink: PropTypes.bool,
};

export default MarkdownLink;
